import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=7e1d954a&scoped=true"
import script from "./EmptyList.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=7e1d954a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1d954a",
  null
  
)

export default component.exports